module.exports = __webpack_public_path__ + "img/mgh-kyobashi-sp@2x.8a5f5bd2.jpg";